<template>
  <div>
    <Header></Header>
    <Search :seachcon="keyword" :catid="id"></Search>
    <Nav></Nav>
    <div class="container">
      <div class="wrap clearfloat">
        <div class="left">
          <div class="head">
            <div class="header">
              <div class="call">
                <p class="title">{{ bidDetail.title }}</p>
                <p class="gonggao">公告</p>
              </div>
              <div class="call_status">
                <div class="call_btns">
                  <div class="d-flex align-items-center">
                    <template v-if="bidDetail.is_join == 1">
                      <div class="call_btn call_look_detail" @click="tendetail">查看详情</div>
                    </template>
                    <template v-else>
                      <template v-if="bidDetail.status == 1">
                        <div class="call_btn" @click="tenderbid">立即投标</div>
                      </template>

                      <div class="call_off" v-if="bidDetail.status == 2">
                        已截止
                      </div>
                    </template>
                  </div>

                  <div class="call_time">
                    截止投标&nbsp;剩余<span>{{ bidDetail.residue_time }}</span
                    >天
                  </div>
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="item">
                <span class="label">采购商</span>{{ bidDetail.name }}
              </div>
              <div class="item">
                <span class="label">发布时间</span>{{ bidDetail.addtime }}
              </div>
              <div class="item">
                <span class="label">项目编号</span>{{ bidDetail.tender_no }}
              </div>
            </div>
          </div>
          <div
            class="bidding"
            v-if="bidDetail.publicity_list && bidDetail.publicity_list.length"
          >
            <div class="nav_title">
              <span>中标公示</span>
            </div>
            <div class="bidist">
              <div
                class="item"
                v-for="(item, index) in bidDetail.publicity_list"
                :key="index"
              >
                <div class="head">
                  <img src="../../assets/images/huizhang.png" alt="" />
                  <p class="show-one-lines">{{ item.company }}</p>
                </div>
                <div class="content">{{ item.platform_remark }}</div>
              </div>
            </div>
          </div>
          <div class="nav_main">
            <div class="nav_title">
              <span>采购商品</span>
            </div>
            <div class="bid_table" v-html="bidDetail.tender_content"></div>
          </div>
          <div class="explain">
            <div class="nav_title">
              <span>项目说明</span>
            </div>

            <template v-if="bidDetail.tender_explain">
              <div
                class="explain_title"
                v-html="bidDetail.tender_explain"
              ></div>
            </template>
            <div class="explain_nav" v-if="bidDetail.file_list">
              <div class="explain_down">
                <div
                  class="item"
                  v-for="(item, index) in bidDetail.file_list"
                  :key="index"
                >
                  <img src="../../assets/images/wenjian.png" alt="" />
                  <p class="title">{{ item.file_name }}</p>
                  <p class="btn" @click.stop="downFile(item.file)">下载</p>
                </div>
              </div>
            </div>
          </div>
          <div class="condition">
            <div class="nav_title">
              <span>参标情况</span>
            </div>
            <div class="explain_title">
              {{ bidDetail.reference_way }}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="content">
            <div class="nav_title">
              <span>其它招标推荐</span>
            </div>
            <div class="main">
              <div
                v-for="(item, index) in bidDetail.recommend_list"
                :key="index"
                class="item" @click="tender(item)"
              >
                <div class="head">
                  <p>{{ item.title }}</p>
                </div>
                <div class="nav">
                  <p><span class="label">采购品：</span>{{ item.label }}</p>
                  <p><span class="label">采购商：</span>{{ item.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Search from "@/components/search/search";
import Nav from "@/components/nav/nav";
import Foot from "@/components/foot/foot";
export default {
  data() {
    return {
      keyword: this.$route.query.keyword, // 搜索文字
      id: "",
      bidId: this.$route.query.id,
      shopList: [],
      bidDetail: "",
    };
  },

  components: {
    Search,
    Header,
    Nav,
    Foot,
  },
  created() {
    this.getCallDetail();
  },
  mounted() {},
  methods: {
    getCallDetail() {
      let that = this;
      let params = {
        id: this.bidId,
      };
      this.$api
        .callDetail(params)
        .then((res) => {
          if (res.code == 0) {
            that.bidDetail = res.data;
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下载文件
    downFile(file) {
      if (file) {
        window.open("" + file);
      }
    },
    
    tendetail(){
        let id=this.bidDetail.id;
        this.$router.push({
            path:"/bidparticulars",
            query:{
                id:id
            }
        })
    },
    tenderbid() {
      let id = this.bidDetail.id;
      this.$router.push({
        path: "/bidapply",
        query: {
          id: id,
        },
      });
    },
    tender(item){
      let id=item.id;
      this.$router.replace({
        path:"/bidetails",
        query:{
          id:id
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background: #f2f2f2;
  padding-top: 10px;
  padding-bottom: 37px;
  .wrap {
    width: 1190px;
    margin: 0 auto;
    .left {
      width: 75%;
      float: left;
      .head {
        padding: 0 32px;
        background: #fff;
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 32px;
          padding-bottom: 20px;
          border-bottom: dashed 1px #e6e6e6;
          .call {
            flex: 1;
            .title {
              font-size: 22px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 30px;
            }
            .gonggao {
              margin-top: 15px;
              background: #f0f5ff;
              border-radius: 3px;
              padding: 0 6px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #4177e3;
              line-height: 20px;
              display: inline-block;
            }
          }
          .call_status {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            .call_btns {
              display: inline-block;
            }
            .call_btn {
              width: 136px;
              height: 36px;
              background: #dd2727;
              border-radius: 3px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 20px;
              cursor: pointer;
            }
            .call_look_detail{
              margin-right: 10px;
            }
            .call_off {
              width: 136px;
              height: 36px;
              background: #d5d5d5;
              border-radius: 3px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: no-drop;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 20px;
            }
            .call_time {
              text-align: center;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              margin-top: 9px;
              span {
                color: #dd2727;
                font-size: inherit;
              }
            }
          }
        }
        .nav {
          padding-bottom: 32px;
          margin-top: 26px;
          .item {
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            display: flex;
            align-items: center;
            .label {
              width: 60px;
              flex-shrink: 0;
              margin-right: 22px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              text-align-last: justify;
            }
          }
          .item:first-child {
            margin-top: 0;
          }
        }
      }
      .bidding {
        padding: 32px 0;
        background: #fff;
        margin-top: 10px;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 32px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .bidist {
          padding: 0 34px;
          .item {
            margin-top: 26px;
            .head {
              display: flex;
              align-items: center;
              img {
                width: 21px;
                height: 19px;
              }
              p {
                margin-left: 9px;
                flex: 1;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 25px;
              }
            }
            .content {
              text-indent: 29px;
              margin-top: 12px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
            }
          }
          .item:first-child {
            margin-top: 16px;
          }
        }
      }
      .nav_main {
        padding: 32px 0;
        background: #fff;
        margin-top: 10px;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 32px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .bid_table {
          width: 826px;
          margin: 0 auto;
          margin-top: 12px;
        }
      }
      .explain {
        padding: 32px 0;
        background: #fff;
        margin-top: 10px;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 32px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .explain_title {
          padding: 0 32px;
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
        .explain_nav {
          margin-left: 32px;
          .explain_contact {
            margin-top: 10px;
            .item {
              margin-top: 8px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 24px;
              display: flex;
              align-items: center;
              .label {
                margin-right: 22px;
                width: 60px;
                flex-shrink: 0;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 24px;
                text-align-last: justify;
              }
            }
            .item:first-child {
              margin-top: 0;
            }
          }
          .explain_down {
            margin-top: 20px;
            .item {
              display: flex;
              align-items: center;
              margin-top: 14px;
              img {
                width: 16px;
                height: 16px;
              }
              .title {
                margin-left: 7px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #00a8ff;
                line-height: 20px;
              }
              .btn {
                cursor: pointer;
                margin-left: 16px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #00a8ff;
                line-height: 20px;
              }
            }
            .item:first-child {
              margin-top: 0;
            }
          }
        }
      }
      .condition {
        margin-top: 10px;
        padding: 32px 0;
        background: #fff;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 32px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .explain_title {
          padding: 0 32px;
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
      }
    }
    .right {
      width: calc(25% - 12px);
      margin-left: 12px;
      float: left;
      background: #fff;
      .content {
        padding-top: 20px;
        padding-bottom: 27px;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 16px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .main {
          max-height: 800px;
          overflow-y: auto;
          padding: 0 16px;
          .item {
            margin-top: 16px;
            background: #ffffff;
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
            border-radius: 3px;
            cursor: pointer;
            .head {
              width: 100%;
              height: 36px;
              background: #f2f2f2;
              border-radius: 3px 3px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              p {
                width: 224px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
              }
            }
            .nav {
              display: flex;
              justify-content: center;
              flex-direction: column;
              padding-bottom: 12px;
              p {
                margin-top: 12px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 17px;
                display: flex;
                align-items: center;
                padding-left: 10px;
                .label {
                  width: 50px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 17px;
                  text-align-last: justify;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.bid_table .el-table .el-table__header-wrapper .el-table__header thead tr th {
  background-color: #f5f5f5;
  font-weight: 400;
}
.bid_table .el-table .el-table__header-wrapper {
  background-color: #f5f5f5;
}
</style>